/** @type {import('Simple/types.js').useDataOnChange} */
export default function useDataOnChange(props) {
  return async function onChange(value) {
    if (typeof props.onChange === 'function') {
      props.onChange(value.selected)
    }
  }
}
